import messages from "@smartmixin/i18n/dist/translations/fr.json";

export default messages;
